<template>
  <div class="about-container">
    <img class="title" src="../assets/about-joined-school-title.svg" />
    <section class="joined">
      <ul>
        <li>
          <JoinedSchoolItem
            name="永春校"
            address="台中市南屯區永春東路495號"
            phone="04 2472-6399"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="樹義校"
            address="台中市南區福田路82號"
            phone="04 2262-6643"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="大甲校"
            address="台中市大甲區雁門路168號"
            phone="04 2686-8080"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="霧峰校"
            address="台中市霧峰區樹仁路224號"
            phone="04 2333-2218"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="大里校"
            address="台中市大里區大明路200號"
            phone="04 2487-3566"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="南陽校"
            address="台中市豐原區自強街89號"
            phone="04 2525-4217"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="瑞穗校"
            address="台中市豐原區中正路411號"
            phone="04 2525-0788"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="烏⽇校"
            address="台中市烏⽇區中⼭路⼀段481號"
            phone="04 2337-8631"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="彰化泰和校"
            address="彰化市建國北路26號"
            phone="04 7202-888"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="益民校"
            address="台中市大里區益民路二段61號"
            phone="04 2486-5633"
          />
        </li>
        <li>
          <JoinedSchoolItem
            name="彰化南郭校"
            address="彰化市南校街58號"
            phone="04 7228-548"
          />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import JoinedSchoolItem from "@/components/JoinedSchoolItem.vue";

export default {
  components: {
    JoinedSchoolItem
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  max-width: 580px;
  margin: auto;

  .title {
    display: block;
    margin: 80px auto;
    width: 165px;
  }

  ul {
    padding-left: 21px;
    li {
      list-style-image: url("../assets/joined-school-list-blue.svg");
      margin: 18px 0;

      &:nth-child(even) {
        list-style-image: url("../assets/joined-school-list-yellow.svg");
      }
    }
  }

  .cooperation {
    margin-top: 80px;
    li:nth-child(odd) {
      list-style-image: url("../assets/joined-school-list-green.svg");
    }
  }
}

@media (max-width: 767px) {
  .title {
    margin: 20px auto !important;
  }

  .joined,
  .cooperation {
    margin: auto 50px;
  }
}
</style>
